export const ES = {
  promotions:
    "¡Síguenos para estar al tanto de todas nuestras noticias, ofertas y promociones!",
  cancel: "cancelar",
  services: "SERVICIOS",
  "about-us": "NOSOTROS",
  recommends: "RECOMIENDA",
  the_chef: "EL CHEF",
  menu: "MENÚ",
  "our-menu": "NUESTRO MENÚ",
  enjoy: "¡Que aproveche!",
  deals: "ofertas",
  gastronomy: "Cocina",
  us: "nosotros",
  "book-table": "reservar mesa",
  contact: "contacto",
  subscribe: "suscribirse",
  subscribed: "suscrito",
  "subscribe-to": "Suscribirse a",
  "leave-email":
    "¡Déjanos tu email para enterarte de las últimas novedades y de nuestras ofertas!",
  book_a_table: "reserva mesa",
  table_booked: "¡Mesa reservada!",
  book_table_in: "Reserva tu mesa en",
  book_table_info: "¿Vienes a comer?",
  "book-your-table": "¡Reserva tu mesa!",
  "book-now": "¡reservar!",
  "booking-message-placeholder":
    "Escribe aquí alergias, necesidades especiales, si es un evento especial como cena de negocios o aniversario, etc.",
  "phone-required": "¡Necesitamos su teléfono!",
  added: "Añadidos de momento:",
  "show-alergens": "Mostrar Alérgenos",
  "added-basket": "añadido a la cesta.",
  total: "TOTAL",
  euros: "€",
  basket: "Mi cesta",
  "see-basket": "Ver cesta",
  and: "y",
  "contact-phone-label": "teléfono",
  "contact-name-label": "nombre",
  "see-menu": "¡Ver Menú Completo!",
  "google-directions": "Abrir en Maps",
  "order-home": "¡Llama para pedir a domicilio!",
  loading: "Cargando...",
  number_of_people: "Número de personas",
  choose_date: "Elige tu fecha",
  more_dates: "Más fechas",
  lunch: "Almuerzo",
  dinner: "Cena",
  hour: "Hora",
  close: "¡Cerrar!",
  lounge_or_terrace: "Sala o terraza",
  lounge: "Sala",
  terrace: "Terraza",
  "hour-required": "¡Necesitamos una hora para tu reserva!",
  today: "Hoy",
  tomorrow: "Mañana",
  first_time: "¿Primera vez que nos visita?",
  yes: "Sí",
  no: "No",

  "legend-title": "¡Bienvenidos a Taj Mahal Sevilla!",
  "legend-desc":
    "Le vamos a ayudar a elegir sus platos favoritos. Familiarícese con estos emojis que aparecen al final de la descripción de los mismos. ¡A comer! 🙏🏾👳🏾‍♂️",
  "legend-hot": "Plato picante, bajo responsabilidad del cliente.",
  "legend-star": "¡Platos más pedidos!",
  "legend-flag": "Platos que más gustan al público de origen Indio.",
  "legend-disponibility": "Consulte disponibilidad.",
  understood: "¡Entendido!",

  "1.jpg": "Alérgenos",
  "2.jpg": "Bebidas",
  "3.jpg": "Vinos Indios",
  "4.jpg": "Aperitivos",
  "5.jpg": "Ensaladas",
  "6.jpg": "Huevo & Chaats",
  "7.jpg": "Tandoori & Kadai",
  "8.jpg": "Pollo",
  "9.jpg": "Cordero",
  "10.jpg": "Gambas",
  "11.jpg": "Paneer & Balti",
  "12.jpg": "Vegetariano",
  "13.jpg": "Vegano",
  "14.jpg": "Currys sin Lactosa",
  "15.jpg": "Arroz Naan & Biryani",
  "16.jpg": "Extras",
  "17.jpg": "Extras sin Lactosa",
  "18.jpg": "Postres",
  "19.jpg": "Cafés y Tés",
};

export const EN = {
  promotions:
    "Follow us to keep up to date with promotions and exclusive offers!",
  cancel: "cancel",
  services: "SERVICES",
  "about-us": "ABOUT US",
  recommends: "FAVORITES",
  the_chef: "THE CHEF",
  menu: "MENU",
  "our-menu": "OUR MENU",
  enjoy: "Enjoy our delicious food!",
  deals: "deals",
  gastronomy: "kitchen",
  us: "about",
  "book-table": "book table",
  bookings: "book a table",
  contact: "contact",
  subscribe: "subscribe",
  subscribed: "suscribed",
  "subscribe-to": "Subscribe to",
  "leave-email": "Leave us your email to get our latest offers and promotions!",
  book_a_table: "book a table",
  table_booked: "Table booked!",
  book_table_in: "Book your table at",
  book_table_info: "Coming soon?",
  "book-your-table": "Book your table!",
  "book-now": "¡book now!",
  "booking-message-placeholder":
    "Write here alergies, special requirements, if it's a special event like business dinner or anniversary, etc.",
  "phone-required": "We need your phone!",
  added: "Added so far:",
  "show-alergens": "Show alergens",
  "added-basket": "added to your basket.",
  total: "TOTAL",
  euros: "€",
  basket: "My Basket",
  "see-basket": "Check basket",
  and: "and",
  "contact-phone-label": "phone",
  "contact-name-label": "name",
  "see-menu": "¡See Full Menu!",
  "google-directions": "Open in Maps",
  "order-home": "¡Order home!",
  loading: "Loading...",
  number_of_people: "Number of people",
  choose_date: "Choose your date",
  more_dates: "More dates",
  lunch: "Lunch",
  dinner: "Dinner",
  hour: "Hour",
  close: "Close!",
  lounge_or_terrace: "Lounge or terrace",
  lounge: "Lounge",
  terrace: "Terrace",
  "hour-required": "We need an hour for your reservation!",
  today: "Today",
  tomorrow: "Tomorrow",
  first_time: "Is it the first time you visit us?",
  yes: "Yes",
  no: "No",

  "legend-title": "Welcome to Taj Mahal Sevilla!",
  "legend-desc":
    "We are going to help you find the curry you're looking for! Check the emojis below alongside their meaning & look for them at the end of the description of each curry. Let's eat! 🙏🏾👳🏾‍♂️",
  "legend-hot": "Hot curry, under customers responsability.",
  "legend-star": "Most popular dishes!",
  "legend-flag": "Indian origin customers favourite curries.",
  "legend-disponibility": "Ask for availability.",
  understood: "Understood!",

  "1.jpg": "Alergens",
  "2.jpg": "Drinks",
  "3.jpg": "Indian Wines",
  "4.jpg": "Appetizers",
  "5.jpg": "Salads",
  "6.jpg": "Egg Curry & Chaats",
  "7.jpg": "Tandoori & Kadai",
  "8.jpg": "Chicken",
  "9.jpg": "Lamb",
  "10.jpg": "Prawns",
  "11.jpg": "Paneer & Balti",
  "12.jpg": "Vegetarian",
  "13.jpg": "Vegan",
  "14.jpg": "Lactose Free Curries",
  "15.jpg": "Rice Naan & Biryani",
  "16.jpg": "Extras",
  "17.jpg": "Lactose Free Extras",
  "18.jpg": "Desserts", 
  "19.jpg": "Coffee & Tea",
};



// WEBPACK FOOTER //
// ./src/messages/simpleMenuMessages.js